import { borderRadiusSmall, borderRadiusMedium, borderWidthThick, borderWidthThin, boxShadowFocus, fontSizeDefault, widthInputFields, paddingTextField, spacing40, spacingInset20, heightInputFieldsSmall, zIndexTextFieldLabel } from '../../styles/tokens';

var styles = function styles(theme) {
  return {
    root: {},
    container: {
      width: widthInputFields,
      '&$inputContainerFullWidth': {
        width: '100%'
      }
    },
    // Popper
    popper: {
      zIndex: theme.zIndex.drawer + 1
    },
    // InputContainer
    inputContainer: {
      display: 'inline-flex',
      borderRadius: borderRadiusMedium,
      height: 'auto',
      width: widthInputFields,
      backgroundColor: theme.palette.grey[100],
      '&$inputContainerDisabled': {
        backgroundColor: theme.palette.grey[200]
      }
    },
    inputContainerDisabled: {},
    inputContainerFullWidth: {
      width: '100%'
    },
    // Small input
    smallDatePicker: {},
    smallDatePickerInput: {
      height: heightInputFieldsSmall,
      padding: 0,
      '& input': {
        padding: spacingInset20,
        fontSize: fontSizeDefault
      }
    },
    smallInputLabel: {
      top: '.75rem',
      fontSize: fontSizeDefault,
      '&[data-shrink=true]': {
        display: 'none'
      },
      '&$inputLabelFormControl': {
        left: spacingInset20,
        transform: 'none',
        transition: 'none'
      }
    },
    // Input
    inputRoot: {
      borderRadius: borderRadiusSmall,
      border: "solid " + borderWidthThin + " " + theme.palette.grey[400] + " ",
      '&$inputFocusedError': {
        border: borderWidthThick + " solid " + theme.palette.status.error.fill,
        '&:focused': {
          boxShadow: "0 0 0 " + borderWidthThin + " " + theme.palette.status.error.fill
        }
      }
    },
    focused: {
      boxShadow: boxShadowFocus
    },
    input: {
      height: '1.25rem',
      padding: paddingTextField,
      border: "solid " + borderWidthThin + " transparent",
      borderRadius: borderRadiusMedium,
      '&$inputDisabled': {
        color: theme.palette.grey['500'],
        backgroundColor: theme.palette.grey[200],
        cursor: 'not-allowed',
        outline: 'none',
        '&:hover': {
          cursor: 'not-allowed',
          color: theme.palette.grey['500']
        },
        '&:active': {
          color: theme.palette.grey['500']
        }
      }
    },
    inputDisabled: {},
    inputFocused: {
      borderRadius: borderRadiusMedium,
      boxShadow: boxShadowFocus,
      border: "solid " + borderWidthThin + " " + theme.palette.grey[400] + " ",
      '&$inputFocusedError': {
        boxShadow: "0 0 0 " + borderWidthThick + " " + theme.palette.status.error.fill
      }
    },
    inputFocusedError: {},
    // InputLabel
    inputLabelFormControl: {
      zIndex: zIndexTextFieldLabel,
      left: spacing40,
      transform: 'translate(0, 1.25rem) scale(1)'
    },
    inputLabelShrink: {
      fontSize: fontSizeDefault,
      transform: 'translate(0, .5rem) scale(0.75)'
    },
    // InputAdornment
    inputAdornment: {
      marginRight: '.875rem',
      fill: theme.palette.grey[500],
      '&$disabled': {
        fill: theme.palette.grey[400]
      },
      '&$smallDatePicker': {
        marginRight: '.5rem'
      }
    },
    disabled: {},
    // Icon specific
    calendarIcon: {
      pointerEvents: 'none'
    }
  };
};

export default styles;